import { useEffect, useState, useRef } from "react";
import Button from "../../UI/Button/Button";
import server from "../../../apis/server";
import { useAuth } from "../../../contexts/AuthContext";
import { Link } from "react-router-dom";
import ArticleCreate from "./Create/Create";
import Modal from "../../UI/Modal/Modal";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme

import classes from "./Articles.module.scss";

const Articles = () => {
  const { authUser } = useAuth();

  const [articleList, setArticleList] = useState(null);
  const [colDefs, setColDefs] = useState(null);
  const [clickedArticle, setClickedArticle] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const gridRef = useRef();

  useEffect(() => {
    const getArticles = async () => {
      const articleListRes = await server.get(
        `/articles/org/${authUser.orgId}`,
      );

      setArticleList(articleListRes.data);
      setColDefs([
        { field: "title", filter: true, checkboxSelection: true, flex: 3 },
        {
          field: "author",
          flex: 1,
        },
        {
          field: "published",
          flex: 1,
        },
      ]);
    };
    getArticles();
  }, [setArticleList, setColDefs, authUser]);

  const editSelection = (
    <>
      {selectedRows && selectedRows.length ? (
        <div className={classes.editGrid}>
          <div>{selectedRows.length} Article Selected</div>
          <Button clicked={() => setShowModal(true)}>Delete</Button>
        </div>
      ) : null}
    </>
  );

  return (
    <>
      <h1>Articles</h1>
      {selectedRows && selectedRows.length ? (
        <Modal show={showModal} modalClosed={() => setShowModal(false)}>
          <div className={classes.editModal}>
            <div>
              Are you sure you want to delete{" "}
              {selectedRows.length > 1
                ? `${selectedRows.length} articles`
                : `"${selectedRows[0].title}"`}
              ?
            </div>
            <div className={classes.editModal__Buttons}>
              <Button clicked={() => setShowModal(false)}>Cancel</Button>
              <Button
                clicked={async () => {
                  const idsToDelete = selectedRows.map((row) => row.id);

                  try {
                    // We'll use a POST request for bulk delete to safely send an array body
                    const res = await server.post(`/articles/bulk-delete`, {
                      articleIds: idsToDelete,
                      orgId: authUser.orgId,
                    });

                    if (res.status === 200) {
                      gridRef.current.api.deselectAll(); // Manually clear the grid's internal selection state
                      // Remove all deleted items from the local state
                      const updatedList = articleList.filter(
                        (article) => !idsToDelete.includes(article.id),
                      );
                      setArticleList(updatedList);
                      setSelectedRows(null);
                      setShowModal(false);
                    }
                  } catch (err) {
                    console.error("Bulk delete failed", err);
                  }
                }}
              >
                Delete {selectedRows.length} Articles
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}
      {clickedArticle ? (
        <ArticleCreate
          articleFromList={clickedArticle}
          clearSelectedArticle={setClickedArticle}
          articles={articleList}
          setArticles={setArticleList}
          setSelectedRows={setSelectedRows}
        />
      ) : (
        <>
          <>
            <Button clicked={() => setClickedArticle({ new: true })}>
              Create New Article
            </Button>
          </>
          <br />
          <br />
          <h2>Article List</h2>
          {editSelection}
          <div className={`ag-theme-quartz ${classes.grid}`} style={{}}>
            <AgGridReact
              ref={gridRef}
              rowData={articleList}
              columnDefs={colDefs}
              rowSelection="multiple"
              onRowClicked={(event) => {
                // Only navigate to edit if the selection checkbox wasn't the target
                if (event.event.target.closest(".ag-selection-checkbox"))
                  return;
                setClickedArticle(event.data);
              }}
              onSelectionChanged={() => {
                setSelectedRows(gridRef.current.api.getSelectedRows());
              }}
            />
          </div>
          <br />
        </>
      )}
    </>
  );
};

export default Articles;
